import { UpdateDocumentRequestBody, UpdateDocumentResponse } from '@eigtech/documents-types'
import { ensureDocumentCorn } from '@eigtech/documents-util'
import { Corn } from '@eigtech/shared-corn'
import { contextualPatch, useMutation } from '@eigtech/ui-shared-api'
import { documentsBasePath } from './constants'
import { useInvalidateEntityDocuments } from './getEntityDocuments'

export type UpdateDocumentRequest = UpdateDocumentRequestBody & {
  entityId: Corn
  documentId: string
}

function updateDocument({ documentId, entityId, ...payload }: UpdateDocumentRequest) {
  const documentCorn = ensureDocumentCorn(documentId)

  return contextualPatch<UpdateDocumentResponse>(
    `${documentsBasePath}/${entityId}/${documentCorn}`,
    payload
  )
}

export function useUpdateDocument() {
  const invalidateDocuments = useInvalidateEntityDocuments()

  return useMutation({
    mutationFn: updateDocument,
    onSuccess(__, req) {
      invalidateDocuments(req.entityId)
    },
  })
}
